import dayjs from 'dayjs';

import { OptionalTimeRange } from '@cast/shared-types';
import { SECONDS_IN_DAY, SECONDS_IN_HOUR } from '@cast/utils';

export const getChartStep = (
  range: OptionalTimeRange<string>,
  { isBar }: { isBar: boolean }
): number => {
  const diffInSeconds = dayjs(range.to).diff(dayjs(range.from), 'seconds');

  if (diffInSeconds <= SECONDS_IN_HOUR) {
    return 300;
  }

  if (diffInSeconds <= SECONDS_IN_DAY) {
    return isBar ? 3600 : 300;
  }

  if (diffInSeconds <= SECONDS_IN_DAY * 10) {
    return isBar ? SECONDS_IN_DAY : 300;
  }

  if (diffInSeconds > SECONDS_IN_DAY * 31) {
    return SECONDS_IN_DAY;
  }

  return isBar ? SECONDS_IN_DAY : SECONDS_IN_HOUR;
};
